// extracted by mini-css-extract-plugin
export default {"image":"PaymentsTutorial_image__jIb4-","text":"PaymentsTutorial_text__RtVTj","modal":"PaymentsTutorial_modal__zS1dR"};